import { cn } from "../cn";

export interface SpinnerProps {
  /** Said to a screen reader; leave it off when a word beside the spinner already says it. */
  label?: string;
  className?: string;
}

/**
 * The one working indicator: a 16px ring, a second long. Under reduced motion
 * it holds still, and the word beside it is what says Djinn is working.
 */
export function Spinner({ label, className }: SpinnerProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      className={cn("size-[var(--icon-sm)] shrink-0 motion-safe:animate-spin", className)}
    >
      <circle cx="12" cy="12" r="8.5" opacity="0.25" />
      <path d="M12 3.5a8.5 8.5 0 0 1 8.5 8.5" />
    </svg>
  );
}
